// framework
import { Routes, RouterModule } from '@angular/router';

// Application components
import { ErrorComponent } from './../components/Error/ErrorComponent';
import { GuestsComponent } from './../components/Guests/GuestsComponent';
import { LoginComponent } from './../components/Login/LoginComponent';

import { CanActivateViaAuthGuard } from './../router/AuthGuard';
import { Guests } from '../components/Guests/Guests';
import { Subscriptions } from '../components/Guests/Subscriptions';
import { Parks } from '../components/Guests/Parks';
import { UsersComponent } from '../components/users/users.component';

const appRoutes: Routes = [
  {
    path: '',
    component: GuestsComponent,
    canActivate: [CanActivateViaAuthGuard],
    children: [

      { path: 'guest', component: Guests, canActivate: [CanActivateViaAuthGuard],},
      { path: 'subscriber', component: Subscriptions, canActivate: [CanActivateViaAuthGuard],},
      { path: 'parks', component: Parks, canActivate: [CanActivateViaAuthGuard], },
      { path: 'users', component: UsersComponent, canActivate: [CanActivateViaAuthGuard], }
      ]
  },
  {
    path: 'error404', component: ErrorComponent
  },
  {
    path: 'login', component: LoginComponent
  },
  { path: '**', redirectTo: '' },

];

export const routing = RouterModule.forRoot(appRoutes);
